import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, MenuItem } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { priceCategoryTopaymentMethodMap } from 'constants/paymentMethods';
import { useTranslations } from 'utils/useTranslations';
import { floatWithTwoDigits, valiadateFloatWithTwoDigits } from 'utils/floatWithTwoDigits';
import { FormattedMessage } from 'react-intl';
import cataloguesFetch from '../../../api/Catalogue';
import MaterialSelect from '../../../components/Select';
import { roundTo2 } from 'utils/roundTo2';

export const CatalogueAddModal = ({ open, currentCatalogItem: currentCatalogItemProp, handleClose, toggle, onCatalogUpdateAction }) => {
  const currentCatalogItem = currentCatalogItemProp || {};
  const intl = useTranslations();
  const createOrUpdate = async (formValues, formCtx) => {
    try {
      if (!currentCatalogItemProp) {
        const response = await cataloguesFetch.addCatalogue(localStorage.getItem('accessToken'), formValues);
        onCatalogUpdateAction(response.data);
      } else {
        const response = await cataloguesFetch.editCatalogue(localStorage.getItem('accessToken'), {
          ...formValues,
          catalogItemId: currentCatalogItem._id,
        });
        onCatalogUpdateAction(response);
      }

      formCtx.resetForm();
      toggle();
    } catch (err) {
      console.log(err);
    }
  };

  const { values, handleChange, errors, touched, handleSubmit, resetForm } = useFormik({
    initialValues: {
      compania: currentCatalogItem.compania,
      codigo: currentCatalogItem.codigo,
      descripcion: currentCatalogItem.descripcion,
      disponible: currentCatalogItem.disponible,
      bodega: currentCatalogItem.bodega,
      nombreBodega: currentCatalogItem.nombreBodega,
      precio: roundTo2(currentCatalogItem.precio),
      medida: currentCatalogItem.medida,
      category: currentCatalogItem.category,
      subcategory: currentCatalogItem.subcategory,
      categoria: currentCatalogItem.categoria,
    },
    validationSchema: Yup.object({
      // compania: Yup.number().required(),
      codigo: Yup.number().required(),
      descripcion: Yup.string().required(),
      disponible: Yup.number().required(),
      // bodega: Yup.number().required(),
      nombreBodega: Yup.string().required(),
      precio: Yup.number()
        .test('float', intl('error.incorrect_symbols'), function () {
          // eslint-disable-next-line react/no-this-in-sfc
          return valiadateFloatWithTwoDigits(+this.parent.precio);
        })
        .required(),
      medida: Yup.string().required(),
      category: Yup.string().required(),
      subcategory: Yup.string().required(),
      categoria: Yup.number().required(),
    }),
    onSubmit: createOrUpdate,
    enableReinitialize: true,
  });

  const toggleWithReset = () => {
    resetForm();
    handleClose();
  };
  return (
    <Dialog open={open} onClose={toggleWithReset} aria-labelledby="form-dialog-title" style={{ width: '100%' }}>
      <DialogTitle id="form-dialog-title">
        <FormattedMessage id="catalogue.add_new_item" description="Add new catalogue" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage id="catalogue.provide_info" description="SKU" />
        </DialogContentText>

        <TextField
          margin="dense"
          id="codigo"
          name="codigo"
          label={<FormattedMessage id="catalogue.codigo" description="Codigo" />}
          type="number"
          error={touched.codigo && errors.codigo}
          onChange={handleChange}
          value={values.codigo}
          fullWidth
        />
        <TextField
          margin="dense"
          name="descripcion"
          id="descripcion"
          onChange={handleChange}
          error={touched.descripcion && errors.descripcion}
          value={values.descripcion}
          label={<FormattedMessage id="catalogue.descripcion" description="Description" />}
          type="text"
          fullWidth
        />
        <TextField
          name="disponible"
          margin="dense"
          value={values.disponible}
          error={touched.disponible && errors.disponible}
          onChange={handleChange}
          id="disponible"
          label={<FormattedMessage id="catalogue.disponible" description="Available" />}
          type="number"
          fullWidth
        />
        {/* <TextField
          autoFocus
          name="compania"
          margin="dense"
          value={values.compania}
          error={touched.compania && errors.compania}
          onChange={handleChange}
          id="compania"
          label={
            <FormattedMessage id="catalogue.compania" description="Company" />
          }
          type="number"
          fullWidth
        /> */}
        {/* <TextField
          name="bodega"
          margin="dense"
          value={values.bodega}
          error={touched.bodega && errors.bodega}
          onChange={handleChange}
          id="bodega"
          label={<FormattedMessage id="catalogue.bodega" description="Store" />}
          type="number"
          fullWidth
        /> */}
        <TextField
          name="nombreBodega"
          margin="dense"
          value={values.nombreBodega}
          error={touched.nombreBodega && errors.nombreBodega}
          onChange={handleChange}
          id="nombreBodega"
          label={<FormattedMessage id="catalogue.nombreBodega" description="Store number" />}
          type="text"
          fullWidth
        />
        <TextField
          name="precio"
          margin="dense"
          value={values.precio}
          error={touched.precio && errors.precio}
          min="0"
          onChange={handleChange}
          id="precio"
          label={<FormattedMessage id="catalogue.precio" description="Price" />}
          type="number"
          fullWidth
        />
        <TextField
          name="medida"
          margin="dense"
          value={values.medida}
          error={touched.medida && errors.medida}
          onChange={handleChange}
          id="medida"
          label={<FormattedMessage id="catalogue.medida" description="Measure" />}
          type="text"
          fullWidth
        />

        <MaterialSelect
          options={[
            {
              value: 'inventory',
              name: <FormattedMessage id="inventory_type.inventory" description="Inventory" />,
            },
            {
              value: 'services',
              name: <FormattedMessage id="inventory_type.services" description="Services" />,
            },
          ]}
          value={values.category}
          error={touched.category && errors.category}
          onChange={handleChange}
          name="category"
          title={<FormattedMessage id="catalogue.category" description="Category" />}
          style={{ marginBottom: 10 }}
        />
        <MaterialSelect
          options={
            values.category === 'inventory'
              ? [
                  {
                    value: 'medicine',
                    name: <FormattedMessage id="inventory_type.medicine" description="Medicine" />,
                  },
                  {
                    value: 'supply',
                    name: <FormattedMessage id="inventory_type.supply" description="Supply" />,
                  },
                ]
              : [
                  {
                    value: 'service',
                    name: <FormattedMessage id="inventory_type.service" description="Service" />,
                  },
                  {
                    value: 'exam',
                    name: <FormattedMessage id="inventory_type.exam" description="Exam" />,
                  },
                ]
          }
          value={values.subcategory}
          error={touched.subcategory && errors.subcategory}
          onChange={handleChange}
          name="subcategory"
          title={<FormattedMessage id="catalogue.subcategory" description="Subcategory" />}
        />
        <TextField
          // type="number"
          select
          name="categoria"
          value={values.categoria}
          label={<FormattedMessage id="catalogue.price_category" description="Price category" />}
          fullWidth
          onChange={handleChange}
          error={touched.categoria && errors.categoria}
        >
          {Object.entries(priceCategoryTopaymentMethodMap).map(([priceCategory, paymentMethod]) => (
            <MenuItem value={+priceCategory}>
              <FormattedMessage id={`payment_type.${paymentMethod}`} />
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>

      <DialogActions>
        <Button onClick={toggleWithReset} color="secondary">
          <FormattedMessage id="catalogue.cancel" description="Cancel" />
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          <FormattedMessage id="catalogue.add" description="Add" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
